import { Button, Modal } from '@iwoca/orion';
import classnames from 'classnames';
import { connect } from 'react-redux';

import styles from './DEApprovalPropability.module.css';
import { FilledCheckCircleSVG } from '../../../svgComponents/FilledCheckCircleSVG/FilledCheckCircleSVG';
import RocketSVG from '../../../svgComponents/rocketSVG/RocketSVG';
import SilhouetteWithCrossSVG from '../../../svgComponents/silhouetteWithCrossSVG/SilhouetteWithCrossSVG';
import { CONTINUE_TO_FINAL_STEP } from '../AutomatedLendingDecision.actions';

export const DE_AP_HIGH_PROBABILITY = 'DE_AP_HIGH_PROBABILITY';
export const DE_AP_MEDIUM_PROBABILITY = 'DE_AP_MEDIUM_PROBABILITY';
export const DE_AP_LOW_PROBABILITY = 'DE_AP_LOW_PROBABILITY';

const mapDispatchToProps = {
    continueToFinalStep: () => ({ type: CONTINUE_TO_FINAL_STEP })
};

const DEApprovalPropability = ({
    lendingDecisionStep,
    show,
    onClose,
    continueToFinalStep
}) => {
    if (lendingDecisionStep === 'DE_AP_HIGH_PROBABILITY') {
        /**
         * This will become relevent when the probability modal is fully defined
         * Currently it doesn't support high probability to a level that's sufficient for DE
         */
        return (
            <DEApprovalPropabilityModal
                show={show}
                onClose={onClose}
                title={
                    <>
                        <span className={styles.propabilityLevel}>
                            Sehr hohe{' '}
                        </span>
                        Zusagewahrscheinlichkeit
                    </>
                }
                icon={<RocketSVG className={styles.icon} />}
                colour="green">
                <h3 className={styles.modalSubtitle}>
                    Sehr aussichtsreiche Anfrage
                </h3>
                <p className={styles.modalCopy}>
                    Die Wahrscheinlichkeit für ein Kreditangebot ist sehr hoch.
                    Wir benötigen nur noch wenige Informationen und Dokumente,
                    um eine endgültige Entscheidung zu treffen.
                </p>
                <div className={styles.buttonContainer}>
                    <Button onClick={continueToFinalStep}>
                        Weiter zum nächsten Schritt
                    </Button>
                </div>
            </DEApprovalPropabilityModal>
        );
    }

    if (lendingDecisionStep === 'DE_AP_MEDIUM_PROBABILITY')
        return (
            <DEApprovalPropabilityModal
                show={show}
                onClose={onClose}
                title={
                    <>
                        <span className={styles.propabilityLevel}>Gute </span>
                        Zusagewahrscheinlichkeit
                    </>
                }
                icon={
                    <FilledCheckCircleSVG
                        className={classnames(styles.icon, styles.checkCircle)}
                    />
                }
                colour="blue">
                <h3 className={styles.modalSubtitle}>
                    Aussichtsreiche Anfrage
                </h3>
                <p className={styles.modalCopy}>
                    Die Wahrscheinlichkeit für ein Kreditangebot ist gut. Wir
                    benötigen nur noch wenige Informationen und Dokumente, um
                    eine endgültige Entscheidung zu treffen.
                </p>
                <div className={styles.buttonContainer}>
                    <Button onClick={continueToFinalStep}>
                        Weiter zum nächsten Schritt
                    </Button>
                </div>
            </DEApprovalPropabilityModal>
        );

    if (lendingDecisionStep === 'DE_AP_LOW_PROBABILITY')
        return (
            <DEApprovalPropabilityModal
                show={show}
                onClose={onClose}
                title={
                    <>
                        <span className={styles.propabilityLevel}>
                            Sehr geringe{' '}
                        </span>
                        Zusagewahrscheinlichkeit
                    </>
                }
                icon={<SilhouetteWithCrossSVG className={styles.icon} />}
                colour="black">
                <h3 className={styles.modalSubtitle}>Schade!</h3>
                <p className={styles.modalCopy}>
                    Die Wahrscheinlichkeit für ein Kreditangebot ist leider sehr
                    gering. Wir können momentan leider kein Kreditangebot
                    unterbreiten. Bei Rückfragen stehen wir Ihnen gerne
                    telefonisch unter{' '}
                    <a href="tel:+496994323020">069-9432 3020</a> zur Verfügung.
                </p>
                <div className={styles.buttonContainer}>
                    <Button
                        href="/partner/account/"
                        variant="secondary-alt"
                        className={styles.ctaNoUnderline}>
                        Zurück zum Portal
                    </Button>
                </div>
            </DEApprovalPropabilityModal>
        );

    return null;
};

const DEApprovalPropabilityModal = ({
    icon,
    title,
    show,
    onClose,
    colour,
    children
}) => (
    <Modal
        className={classnames(
            styles.DEApprovalPropabilityModal,
            styles[`modal--${colour}`]
        )}
        isOpen={show}
        onClose={onClose}
        data-testid="approval-probability-modal">
        <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
                {icon}
                <h2
                    className={styles.modalTitle}
                    data-testid="approval-probability-title">
                    {title}
                </h2>
            </div>
            <div
                data-testid="loan-modal-contents"
                className={styles.modalDescription}>
                {children}
            </div>
        </div>
    </Modal>
);

export default connect(null, mapDispatchToProps)(DEApprovalPropability);
